import { render, staticRenderFns } from "./SettingShowAccountTab.vue?vue&type=template&id=a1a02d58&"
import script from "./SettingShowAccountTab.vue?vue&type=script&lang=js&"
export * from "./SettingShowAccountTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports